import { animated } from "@react-spring/web";
import classcat from "classcat";
import React from "react";

import { IconHomeAlt } from "@touchtech/web-baselayer-ui";

import css from "./ConfirmedOrderView.module.css";
import useManageConfirmedOrderView from "./hooks/useManageConfirmedOrderView";

const ConfirmedOrderView = () => {
  const { windowWidth, t, styles, titles, handleHomeButtonClick, animatedRef } =
    useManageConfirmedOrderView();

  return (
    <div className={css.container}>
      <div className={css.titleContainer}>
        <div
          className={classcat([
            { "text-headline-5xl": windowWidth > 834 },
            { "text-headline-4xl": windowWidth <= 834 },
            css.title,
          ])}
        >
          {titles.title}
        </div>
        <div className="text-label-2xl">{titles.subtitle}</div>
      </div>
      <button
        ref={animatedRef}
        className={classcat(["text-button-xl text-white", css.homeButton])}
        onClick={handleHomeButtonClick}
      >
        <animated.div
          className={css.animatedButtonFill}
          style={styles}
        ></animated.div>
        <animated.div className={css.animatedButtonContent}>
          <IconHomeAlt />
          {t("Home")}
        </animated.div>
      </button>
    </div>
  );
};

export default ConfirmedOrderView;
